import { Component } from '@angular/core';

@Component({
    selector: 'app-hardfacing-data',
    templateUrl: './hardfacing-data.component.html',
    styleUrl: './hardfacing-data.component.css',
    standalone: false
})
export class HardfacingDataComponent {

}
